import React from "react";
import { Upload as CUpload } from "antd";
import { RcFile, UploadChangeParam, UploadFile } from "antd/es/upload";
import Icon from "../icon";
const { Dragger } = CUpload;
import { FiUpload } from "react-icons/fi";

interface IUploadProps {
  multiple?: boolean;
  fileList?: UploadFile<any>[] | undefined;
  onDrop?: (event: React.DragEvent) => void;
  onChange?: (event: UploadChangeParam<UploadFile<any>>) => void;
  label?: string;
  isRequired?: boolean;
  disabled?: boolean
}

const Upload: React.FC<IUploadProps> = ({
  multiple,
  fileList,
  onDrop,
  onChange,
  label,
  isRequired,
  disabled
}) => {
  const beforeUpload = (file: RcFile) => {
    return false;
  };

  return (
    <div className="a-upload">
      <label>
        {label}
        {isRequired && (
          <span
            style={{
              color: "#f00",
            }}
          >
            *
          </span>
        )}
      </label>
      <Dragger
        multiple={multiple}
        onDrop={onDrop}
        onChange={onChange}
        beforeUpload={beforeUpload}
        fileList={fileList}
        showUploadList={{
          showDownloadIcon: true,
          downloadIcon: "Download",
        }}
        disabled={disabled}
      >
        <p className="ant-upload-drag-icon">
          <Icon component={<FiUpload />} />
        </p>
        <p className="ant-upload-text">Tải file lên</p>
      </Dragger>
    </div>
  );
};

export default Upload;
